import CementBori from './imgs/cementbori.png';
const CementData = [
    {
        id:"1",
        imgsrc: CementBori,
        title: "Ambuja Cement",
        qty: "10kg",
        cost: "₹300.00"
    },
    {
        id:"2",
        imgsrc: CementBori,
        title: "Laxmi Cement",
        qty: "12kg",
        cost: "₹600.00"
    },
    {
        id:"3",
        imgsrc: CementBori,
        title: "Bangur Cement",
        qty: "12kg",
        cost: "₹600.00"
    },
    {
        id:"4",
        imgsrc: CementBori,
        title: "Bangur Cement",
        qty: "12kg",
        cost: "₹500.00"
    },
    {
        id:"5",
        imgsrc: CementBori,
        title: "Jaypee Cement",
        qty: "15kg",
        cost: "₹1000.00"
    },
    {
        id:"6",
        imgsrc: CementBori,
        title: "Jaypee Cement",
        qty: "15kg",
        cost: "₹1000.00"
    },
    {
        id:"7",
        imgsrc: CementBori,
        title: "Jaypee Cement",
        qty: "15kg",
        cost: "₹1000.00"
    },
    {
        id:"8",
        imgsrc: CementBori,
        title: "Jaypee Cement",
        qty: "15kg",
        cost: "₹1000.00"
    },
    {
        id:"9",
        imgsrc: CementBori,
        title: "Jaypee Cement",
        qty: "15kg",
        cost: "₹1000.00"
    },
    {
        id:"10",
        imgsrc: CementBori,
        title: "Jaypee Cement",
        qty: "15kg",
        cost: "₹1000.00"
    },
];
export default CementData;